import {t} from "i18next";

export const RUP_BASE_TYPES = () => {
  return [
    {
      id: 1,
      caption: t('rup:typeClass9')
    },
    {
      id: 2,
      caption: t('rup:typeClass11ohcnoe')
    },
    {
      id: 3,
      caption: t('rup:typeClass11zaochnoe')
    },
    {
      id: 10,
      caption: t('rup:typeTipo2courseOchnoe')
    },
    {
      id: 11,
      caption: t('rup:typeTipo2courseZaochnoe')
    },
    {
      id: 20,
      caption: t('rup:typeTipo3courseOchnoe')
    },
    {
      id: 21,
      caption: t('rup:typeTipo3courseZaochnoe')
    },
  ]
}